/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.3.0
 */

import { PageTitle } from '../../../components/common';
import { initTranslation } from '../../../modules/internationalization/constants';
import { ICommonPageTranslation } from '../../../modules/internationalization/types';
import { IPageSettingsTranslation } from '../../../modules/internationalization/types/pages/pageSettings';

export interface IPageSettingsTitleProps {
    translation: ICommonPageTranslation<IPageSettingsTranslation>;
}

const PageSettingsTitle = (props: IPageSettingsTitleProps) => {
    return <PageTitle dataName={'settings'} title={props.translation.title.label}/>
};

PageSettingsTitle.defaultProps = {
    translation: initTranslation.pageSettings,
};

export default PageSettingsTitle;
